// page -> element -> language
// e.g home page -> hrMobile label -> language

export const language = {
  homePage: {
    hrMobile: {
      en: 'HR Mobile',
      th: 'หน้าหลัก',
    },
    OrderHistory: {
      en: 'Order History',
      th: 'ประวัติการสั่งซื้อ',
    },
    Addtocart: {
      en: 'Add to cart',
      th: 'เพิ่มลงตะกร้าสินค้า',
    },
    Filter: {
      Range: {
        en: 'Price',
        th: 'ช่วงราคา',
      },
      Size: {
        en: 'Size',
        th: 'ขนาด',
      },
      stock: {
        en: 'Stock',
        th: 'สต็อก',
      },
      availableStock: {
        en: 'Available Stock',
        th: 'มีสินค้าในสต็อก',
      },
      onSales: {
        en: 'Last Chance',
        th: 'Last Chance',
      },
      TextSize: {
        en: 'One Size',
        th: 'ขนาดเดียว',
      },
    },
    Cart: {
      cart: {
        en: 'Cart',
        th: 'ตะกร้าสินค้า',
      },
      CheckOut: {
        en: 'Check out',
        th: 'ชำระเงิน',
      },
      ConfirmPayment: {
        en: 'Confirm payment',
        th: 'ยืนยัน การชำระเงิน',
      },
      Ordertotal: {
        en: 'Order total',
        th: 'รวมสั่งชื้อ',
      },
      TransactionFee: {
        en: 'Transaction fee',
        th: 'ค่าธรรมเนียมการทำธุรกรรม',
      },
      NetTotal: {
        en: 'Net Total',
        th: 'รวมทั้งหมด',
      },
      PromptPay: {
        en: 'PromptPay',
        th: 'พร้อมเพย์',
      },
      MobileBanking: {
        en: 'Mobile Banking',
        th: 'การชำระเงินผ่านแอปพลิเคชันบนสมาร์ตโฟน',
      },
      QRPayment: {
        en: 'QR payment',
        th: 'ชำระเงินผ่านคิวอาร์โค้ด',
      },
      Expired: {
        en: 'QR payment expired!',
        th: 'คิวอาร์โค้ดหมดอายุ',
      },
      btnOK: {
        en: 'OK',
        th: 'ตกลง',
      },
      BtnDownload: {
        en: 'Download',
        th: 'ดาวน์โหลด',
      },
      TimeOut: {
        en: 'Timeout',
        th: 'หมดเวลา',
      },
      Minutes: {
        en: 'mins',
        th: 'นาที',
      },
      OutOfStock: {
        en: 'Out of stock!',
        th: 'สินค้าหมด',
      },
      Removeitem: {
        en: 'Remove item',
        th: 'ลบสินค้า',
      },
      Quantity: {
        en: 'Quantity',
        th: 'จำนวน',
      },
    },
    Warning: {
      en: 'Warning!',
      th: 'แจ้งเตือน!',
    },
    WarningRemove: {
      en: 'Are you sure to remove item?',
      th: 'คุณแน่ใจที่จะลบสินค้านี้ใช่ไหม!',
    },
    ProductOutOfStock: {
      en: 'This product is out of stock!',
      th: 'สินค้าชิ้นนี้หมด!',
    },
    selectSize: {
      en: 'Please select size!',
      th: 'กรุณาเลือกขนาด!',
    },
    btnOK: {
      en: 'OK',
      th: 'ตกลง',
    },
    btnCancel: {
      en: 'Cancel',
      th: 'ยกเลิก',
    },
    limitMessageFrist: {
      en: 'Your purchase reached to maximum limit [',
      th: 'การชื้อของคุณถึงขีดจำกัดสูงสุด [',
    },
    limitMessageLast: {
      en: ' items] for current month!',
      th: ' ชิ้น] สำหรับเดือนนี้',
    },
    LoadingMoreItems: {
      en: 'Loading more items..',
      th: 'แสดงสินค้าเพิ่มเติม..',
    },
    Norecords: {
      en: 'No records!',
      th: 'ไม่พบสินค้า',
    },
  },
  status: {
    en: 'Status',
    th: 'สถานะ',
  },
  OrderStatus: {
    en: 'Order Status',
    th: 'สถานะคำสั่งซื้อ',
  },
  payment: {
    en: 'Payment',
    th: 'จ่ายเงิน',
  },
  total: {
    en: 'Total',
    th: 'ทั้งหมด',
  },
  promptPay: {
    en: 'PromptPay',
    th: 'พร้อมเพย์',
  },
  banking: {
    en: 'Mobile Banking',
    th: 'ธนาคาร',
  },
  qrExpired: {
    en: 'QR is expired!',
    th: 'คิวอาร์หมดอายุ',
  },
  thankYou: {
    en: 'Thank you',
    th: 'ขอบคุณ',
  },
  clear: {
    en: 'Clear',
    th: 'ล้างตัวกรอง',
  },
  orderProbationWaring: {
    en: 'Eligible for only who already passed probation period!',
    th: 'คุณสามารถซื้อสินค้าราคาพิเศษได้เมื่อผ่านช่วงเวลาทดลองงานแล้วเท่านั้น',
  },
  orderTempEmpWaring: {
    en: 'According to company policy, you are not eligible to purchase these items.',
    th: 'คุณไม่มีสิทธิ์ซื้อสินค้าเหล่านี้ ตามข้อกำหนดของบริษัท',
  },
  termAndCondition: {
    text: {
      en: 'I agree to the',
      th: 'ฉันยอมรับ',
    },
    link: {
      en: 'terms & conditions',
      th: 'ข้อกำหนดและเงื่อนไข',
    },
  },
  privacyPolicy: {
    link: {
      en: 'privacy policy',
      th: 'นโยบายความเป็นส่วนตัว',
    },
  },
  note: {
    en: 'Note',
    th: 'หมายเหตุ',
  },
  ok: {
    en: 'OK',
    th: 'ตกลง',
  },
  pay: {
    en: 'Pay',
    th: 'จ่าย',
  },
  Timeout: {
    en: 'Timeout',
    th: 'หมดเวลา',
  },
  minutes: {
    en: 'minutes',
    th: 'นาที',
  },
  seconds: {
    en: 'seconds',
    th: 'วินาที',
  },
  order_N: {
    en: 'Order',
    th: 'การสั่งซื้อ',
  },
  paymentFailed: {
    en: 'Payment failed',
    th: 'ชำระเงินไม่สำเร็จ',
  },
  warning: {
    en: 'Warning!',
    th: 'แจ้งเตือน!',
  },
  postPaymentSuccessMsg: {
    en: `You successfully placed orders. Please collect this order number for reference.`,
    th: `ระบบได้รับคำสั่งซื้อของท่านแล้ว กรุณาจดเลขคำสั่งซื้อนี้ไว้`,
  },
  postPaymentFailMsg: {
    en: `Your payment has been terminated.`,
    th: `คำสั่งซื้อของคุณถูกยกเลิก`,
  },
  somethingWentWrong: {
    en: `Something went wrong!`,
    th: `ไม่สามารถทำรายการได้`,
  },
  checkoutItemsNotAvailable: {
    en: `Some items are not available. Please review the cart again!`,
    th: `สินค้าบางรายการของคุณหมดแล้ว กรุณาตรวจสอบตะกร้าของคุณอีกครั้ง`,
  },
  noRecords: {
    en: 'No records.',
    th: 'ไม่พบข้อมูล',
  },
  maintenanceMsg: {
    firstLine: {
      en: `We'll be back very soon..`,
      th: `รอหน่อยนะ..`,
    },
    secondLine: {
      en: `Preparing products for your next exciting experience!!`,
      th: `เรากำลังเตรียมสินค้าที่น่าสนใจสำหรับวันพรุ่งนี้!!`,
    },
  },
  disableTPPPAppMsg: {
    firstLine: {
      en: `Order will be resumed on `,
      th: `คุณสามารถซื้อสินค้าครั้งถัดไปในวันที่ `,
    },
  },
  lastDateBuyBannerMsg: {
    en: `The last purchasing date will be on June 12th, 2025.`,
    th: `คุณสามารถสั่งซื้อสินค้าได้ถึงวันที่ 12 มิถุนายน 2568.`,
  },
  lastDateBuyFullScreenMsg: {
    en: `Pandora will be closing the Employee Purchase Program from June 13th 2025 for approximately 8 weeks to perform a systems upgrade to better support our customers. Customer can check the order status as usual.`,
    th: `แพนดอร่าจะปิดระบบสั่งซื้อสินค้าสำหรับพนักงาน ตั้งแต่วันที่ 13 มิถุนายน 2568 เป็นเวลาประมาณ 8 สัปดาห์ เพื่อดำเนินการปรับปรุงระบบให้ดียิ่งขึ้น ทั้งนี้พนักงานสามารถตรวจสอบสถานะการสั่งซื้อสินค้าได้ตามปรกติ.`,
  },
  cancel: {
    en: 'Cancel',
    th: 'ยกเลิก',
  },
  payAgainMsg: {
    en: 'Payment failed! Please pay again!',
    th: 'ชำระเงินไม่สำเร็จ กรุณาลองใหม่อีหครั้ง',
  },
  close: {
    en: 'Close',
    th: 'ปิด',
  },
  cancelOrderByUser: {
    en: 'Cancel order',
    th: 'ยกเลิกคำสั่งซื้อ',
  },
  cancelOrderByUserWarningAlert: {
    en: 'Are you sure to cancel the order?',
    th: 'คุณยืนยันที่จะยกเลิกคำสั่งซื้อนี้ใช่หรือไม่?',
  },
  cancelOrderByUserPostAlert: {
    en: 'Order has been cancelled!',
    th: 'ดำเนินการยกเลิกคำสั่งซื้อเรียบร้อยแล้ว!',
  },
  statusHistories: {
    en: 'Status histories',
    th: 'ประวัติสถานะ',
  },
  pendingWarningAlert: {
    en: 'You have pending payment. Please go back to order histories to continue or cancel the order.',
    th: 'คุณมีรายการสั้งซื้อรอชำระเงินอยู่ คุณสามารถทำรายต่อได้โดยเข้าไปที่เมนูประวัติการสั่งซื้อเพื่อทำรายการต่อหรือยกเลิกคำสั่งซื้อ.',
  },
  pendingWarningAlertToHistories: {
    en: 'Order histories',
    th: 'ประวัติคำสั่งซื้อ',
  },
  pendingWarningAlertToNew: {
    en: 'Make a new order',
    th: 'สร้างคำสั่งซื่อใหม่',
  },
  orderHistoryRepayAlert: {
    title: {
      en: 'Same payment!',
      th: 'รายการการชำระเงินซ้ำกับรายการก่อนหน้า',
    },
    message: {
      en: 'You are about to make a similar payment - same amount, same recipient. Please wait for few minuets to prevent the same transaction.',
      th: 'คุณเพิ่งโอนเงินจำนวนนี้ให้กับผู้รับคนเดิม กรุณารอสักครู่เพื่อตรวจสอบรายละเอียดและป้องกันการชำระเงินซ้ำ',
    },
  },
  collections: {
    en: 'Collections',
    th: 'คอลเลกชัน',
  },
};
